import { Mutations } from "vuex-smart-module";
import { MutationTypes } from "../mutations-types";
import FeaturesState from "./state";
import {
  IChannels,
  IChartAchare,
  IFixedPlatforms,
  ILinealPlatforms,
  IMobilePlatforms,
  IPipelines,
} from "./models";

export default class FeaturesMutations extends Mutations<FeaturesState> {
  //Carga de datos
  [MutationTypes.SET_FIXED_PLATFORMS](platforms: IFixedPlatforms[]) {
    this.state.fixedPlatforms = platforms;
  }
  [MutationTypes.SET_MOBILE_PLATFORMS](platforms: IMobilePlatforms[]) {
    this.state.mobilePlatforms = platforms;
  }
  [MutationTypes.SET_LINEAL_PLATFORMS](platforms: ILinealPlatforms[]) {
    this.state.linealPlatforms = platforms;
  }
  [MutationTypes.SET_PIPELINES](pipelines: IPipelines[]) {
    this.state.pipelines = pipelines;
  }
  [MutationTypes.SET_CHANNELS](channels: IChannels[]) {
    this.state.channels = channels;
  }
  [MutationTypes.SET_CHART_ACHARE](achare: IChartAchare[]) {
    this.state.chartAchare = achare;
  }
  //Seleccion de plataformas
  [MutationTypes.SET_SELECTED_FIXED_PLATFORM](platform: IFixedPlatforms) {
    this.state.selectedFixedPlatform = platform.id;
  }
  [MutationTypes.SET_SELECTED_MOBILE_PLATFORM](platform: IMobilePlatforms) {
    this.state.selectedMobilePlatform = platform.id;
  }
  [MutationTypes.ERASE_SELECTED_FEATURES]() {
    this.state.selectedFixedPlatform = 0;
    this.state.selectedMobilePlatform = 0;
  }
  [MutationTypes.CHANGE_PLATFORM_TAG](status: boolean) {
    this.state.platformTag = status;
  }
}
